import styled from 'styled-components';

const FooterWrapper = styled.div`
    align-items: center;
    background: black;
    box-sizing: border-box;
    color: white;
    display: flex;
    justify-content: space-between;
    height: 30px;
    padding: 0 15px;
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 2;

    a, span {
        color: white;
        font-size: 0.5rem;
    }

    @media (min-width: 768px) {
        a, span {
            color: white;
            font-size: 0.8rem;
        }
    }
`

const Footer = () => {
    return (
        <FooterWrapper>
            <a href="#">Terms and Conditions</a>
            <span>© 2025. All rights reserved.</span>
        </FooterWrapper>
    )
}

export default Footer;